<template>
    <b-modal id="popup-alert-modal" hide-header hide-footer centered size="lg">
        <template #default="{close}">
            <div class="row mt-3 mb-3">
                <div class="col col-auto align-self-center">
                    <b-icon icon="exclamation-octagon" />
                </div>
                <div class="col">
                    <p>
                    Toto je výstup Kontroly rizik veřejných zakázek provedený společností Datlab. Její závěry nedokazují pochybení či porušení zákona.
                    Zjištěná rizika znamenají pouze vyšší možnost výskytu takových situací. Neměla by proto sama o sobě být kladena k tíži zadavatele ani dodavatele.
                    Kontrola jako celek má sloužit jako vstup pro lepší nastavení vnitřních kontrolních postupů či hloubkový audit.
                    </p>
                </div>
            </div>

            <b-button @click="close" size="sm" variant="outline-dark" block>{{ $t('button.close') }}</b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    mounted: function() {
        if (!this.$cookies.get('analysis-caveat-shown')) {
            this.$bvModal.show('popup-alert-modal')
            this.$cookies.set('analysis-caveat-shown', true, '7d')
        }
    }
}
</script>

<style lang="scss">
@import "src/scss/_custom";

#popup-alert-modal {
    .modal-header {
        border-bottom: none;
    }

    .modal-content {
        .col:first-of-type {
            font-size: 50px;
        }

        p {
            font-size: 20px;
        }
    }
}
</style>